<script setup>
import { inject, watch } from 'vue'
import { Label, Text, Checkbox } from '@codinglabsau/ui'
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue
} from '@codinglabsau/gooey'
import IconSelect from '@/Components/Inputs/IconSelect.vue'

const form = inject('form')
const tipTapNodeId = inject('elementId')

const errorKey = (key) => {
  return `content.${tipTapNodeId}.items.${props.id}.${key}`
}

const icon = defineModel('icon')
watch(icon, () => form.forgetError(errorKey('icon')))

const name = defineModel('name')
watch(name, () => form.forgetError(errorKey('name')))

const href = defineModel('href')
watch(href, () => form.forgetError(errorKey('href')))

const switchesTenant = defineModel('switchesTenant')
const tenant = defineModel('tenant')
const viewport = defineModel('viewport')
const meta = defineModel('meta')

const props = defineProps({
  id: {
    type: String,
    required: true,
  },
})
</script>

<template>
  <div>
    <Label for="name">{{ __('Icon') }}</Label>
    <IconSelect v-model="icon" :error="form.errors[errorKey('icon')]" />
  </div>
  <div>
    <Label for="name">{{ __('Name') }}</Label>
    <Text v-model="name" :error="form.errors[errorKey('name')]" />
  </div>
  <div class="mt-1">
    <Label for="href">{{ __('link') }}</Label>
    <Text
      v-model="href"
      :error="form.errors[errorKey('href')]"
      :placeholder="__('e.g. /about or https://example.com/about')"
      :description="__('Note: You do not have to include the locale to a relative path (e.g. /about), it will be applied automatically. Full urls will not have the locale applied to them.')"
    />
  </div>
  <div class="mb-1">
    <Checkbox
      v-model="switchesTenant"
      :label="__('Switches Tenant')"
    />
    <Select v-if="switchesTenant" v-model="tenant">
      <SelectTrigger class="flex-1 mt-2">
        <SelectValue :placeholder="__('Select a tenant')" />
      </SelectTrigger>
      <SelectContent>
        <SelectItem v-for="t in $page.props.header.tenants_in_groups" :key="t.id" :value="t.id">
          {{ t.name }}
        </SelectItem>
      </SelectContent>
    </Select>
  </div>
</template>
